import { render, staticRenderFns } from "./knowledgeDirectory.vue?vue&type=template&id=3bea6936&"
import script from "./knowledgeDirectory.vue?vue&type=script&lang=ts&"
export * from "./knowledgeDirectory.vue?vue&type=script&lang=ts&"
import style0 from "./knowledgeDirectory.vue?vue&type=style&index=0&id=3bea6936&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports